export default "__VITE_ASSET__4448241d__"